var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgMail = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M4.5 4.5H19.5C20.3284 4.5 21 5.17157 21 6V6.3571L12 12.5879L3 6.3571V6C3 5.17157 3.67157 4.5 4.5 4.5ZM1.5 6.73932C1.49991 6.74605 1.49991 6.75277 1.5 6.75949V18C1.5 19.6569 2.84314 21 4.5 21H19.5C21.1569 21 22.5 19.6569 22.5 18V6.7595C22.5001 6.75277 22.5001 6.74604 22.5 6.73931V6C22.5 4.34315 21.1569 3 19.5 3H4.5C2.84314 3 1.5 4.34315 1.5 6V6.73932ZM21 8.18149V18C21 18.8284 20.3284 19.5 19.5 19.5H4.5C3.67157 19.5 3 18.8284 3 18V8.18149L11.5731 14.1167C11.8299 14.2945 12.1701 14.2945 12.4269 14.1167L21 8.18149Z"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgMail);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/mail.9d15b608c5529a4c1b591e4ca9e79798.svg";